import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import { useMarketplacePartnerRegisterPageContext } from '../../components/marketplacePartnerRegisterPageContext'

const getMarketplacePartnerRegisterApiSwrSendEmailKey = (): string => {
  return 'marketplacePartnerRegisterApiSwrSendEmail'
}

export const useMarketplacePartnerRegisterPageFormApiPostMutation = (
  apiCall: () => Promise<void>,
): SWRMutationResponse<void> => {
  const { setIsFormSubmitted } = useMarketplacePartnerRegisterPageContext()

  return useSWRMutation(
    getMarketplacePartnerRegisterApiSwrSendEmailKey(),
    apiCall,
    {
      onSuccess: () => {
        setIsFormSubmitted(true)
      },
    },
  )
}
